import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "customResourceApply" }
const _hoisted_2 = { class: "tableHeader" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { style: {"margin-left":"8px"} }
const _hoisted_5 = { class: "handler" }
const _hoisted_6 = {
  key: 0,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", null, "删除", -1)
const _hoisted_8 = {
  key: 1,
  style: {"display":"flex","justify-content":"space-around"}
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = { class: "div-table" }
const _hoisted_16 = {
  key: 0,
  class: "div-table-row-title"
}
const _hoisted_17 = {
  key: 1,
  class: "div-table-row-content"
}
const _hoisted_18 = { class: "div-table-col-title" }
const _hoisted_19 = {
  key: 0,
  class: "div-table-col-value"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = {
  key: 1,
  class: "div-table-col-value"
}
const _hoisted_24 = {
  key: 2,
  class: "div-table-row-content"
}
const _hoisted_25 = { class: "div-table-col" }
const _hoisted_26 = { class: "div-table-col-title" }
const _hoisted_27 = { class: "div-table-col-value" }
const _hoisted_28 = { style: {"display":"flex","align-items":"center","padding":"20px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"150px"} }, "颜色标记", -1)
const _hoisted_30 = { class: "footer" }

import { searchFormConfig } from './config/search.config'
import { modalTableConfig } from './config/modal.config'
import { computed, onMounted, reactive, ref, watch } from 'vue'
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import {
  deletePageData, downloadData,
  editPageData,
  getListData,
  getPageListData
} from "@/service/main/system";
import type { STablePaginationConfig } from '@surely-vue/table'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import { useStore } from '@/store'
import localCache from '@/utils/cache'
import { ElMessage, ElMessageBox } from 'element-plus'
import { initEmptyParam } from '@/hooks/useInitParam'
import { useUploadSimple } from '@/hooks/useUploadSimple'
import { usePermission } from '@/hooks/usePermission'
import { useRouter } from 'vue-router'
import { resetPassword } from '@/service/account/account'
import { usePageModalTable } from '@/hooks/usePageModalTable'

interface DataItem {
  key: string
  id: string
  createBy: string
  createTime: string
  updateBy: string
  updateTime: string
  deleted: string
  groupId: string
  groupName: string
  applyUserName: string
  applyResourcesNum: string
  applyDesc: string
  wechatNo: string
  corpWechatNo: string
  account: string
  corpId: string
  corpName: string
  remark: string
  applyStatus: string
  empId: string
  upload: string
  actualDivideNum: string
  resourceType: string
  upload0: string
  beginDate: string
  endDate: string
  progress: string
  colleague: string
  nonPrecise: string
  withinTwoMonth: string
  withinAll: string
  difference: string
  verifyTime: string
  verifyUser: string
  progressUser: string
}

const editUrl = '/main/customResourceApply/save'

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomResourceApplySW',
  setup(__props) {

initEmptyParam()

const store = useStore()
const userInfo = store.state.login.userInfo

// 填报
const canReport = usePermission('customResourceApply', 'report')
// 列表查询
const canList = usePermission('customResourceApply', 'list')
// 审核
const canCheck = usePermission('customResourceApply', 'check')
// 打资源
const canDo = usePermission('customResourceApply', 'do')

const canReportEdit: any = ref([])
const canDoEdit: any = ref([])
const columns: any = ref([])
const detail: any = ref([])
const initPermission = () => {
  if (canReport) {
    canReportEdit.value = [
      'applyResourcesNum',
      'applyDesc',
      'wechatNo',
      'corpWechatNo',
      'account',
      'corpId',
      'corpName',
      'remark',
      'upload',
      'upload0'
    ]
  }
  if (canDo) {
    canDoEdit.value = [
      'actualDivideNum',
      'resourceType',
      'beginDate',
      'endDate',
      'colleague',
      'nonPrecise',
      'withinTwoMonth',
      'withinAll',
      'difference'
    ]
  }

  columns.value = [
    {
      title: '组别',
      dataIndex: 'groupName',
      type: 'input',
      width: 100,
      align: 'center',
      resizable: true,
      autoHeight: true,
      fixed: 'left'
    },
    {
      title: '组员',
      dataIndex: 'applyUserName',
      type: 'input',
      width: 80,
      align: 'center',
      resizable: true,
      autoHeight: true,
      fixed: 'left'
    },
    {
      title: '个微',
      dataIndex: 'wechatNo',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 140,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter()
    },
    {
      title: '企微绑定手机号',
      dataIndex: 'corpWechatNo',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 140,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter()
    },
    {
      title: '企微ID',
      dataIndex: 'account',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 140,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter()
    },
    {
      title: '主体',
      dataIndex: 'corpId',
      type: 'corpId',
      editable: 'cellEditorSlot',
      width: 180,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '申请量',
      dataIndex: 'applyResourcesNum',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '资源类型',
      dataIndex: 'resourceType',
      type: 'resourceType',
      width: 100,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      editable: 'cellEditorSlot'
    },
    {
      title: '核对数量',
      dataIndex: 'checkNum',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '打满数量',
      dataIndex: 'actualDivideNum',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '同行',
      dataIndex: 'colleague',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '非精准',
      dataIndex: 'nonPrecise',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '2月内',
      dataIndex: 'withinTwoMonth',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '有效',
      dataIndex: 'difference',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '核对有效',
      dataIndex: 'checkActualNum',
      type: 'textarea',
      autoHeight: true,
      editable: 'cellEditorSlot',
      width: 90,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '重复数量',
      dataIndex: 'withinAll',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 120,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '重复率',
      dataIndex: 'withinAllPer',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 120,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '24小时删除数',
      dataIndex: 'deleteWithin24h',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 120,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '24小时删除率',
      dataIndex: 'deleteWithin24hPer',
      type: 'textarea',
      autoHeight: true,
      editable: false,
      width: 120,
      align: 'center',
      resizable: true,
      valueSetter: getValueSetter()
    },
    {
      title: '资源进度',
      dataIndex: 'progressDesc',
      type: 'input',
      width: 120,
      align: 'center',
      resizable: true,
      autoHeight: true
    },
    {
      title: '申请时间',
      dataIndex: 'createTime',
      type: 'dateTime',
      width: 180,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      editable: 'cellEditorSlot'
    },
    {
      title: '备注',
      dataIndex: 'applyDesc',
      type: 'textarea',
      width: 200,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      autoHeight: true,
      editable: 'cellEditorSlot'
    },
    {
      title: '上线时间',
      dataIndex: 'beginDate',
      type: 'date',
      width: 180,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      editable: 'cellEditorSlot'
    },
    {
      title: '下线时间',
      dataIndex: 'endDate',
      type: 'date',
      width: 180,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      editable: 'cellEditorSlot'
    },
    {
      title: '账号使用人',
      dataIndex: 'usedBy',
      type: 'input',
      width: 80,
      align: 'center',
      resizable: true,
      autoHeight: true
    },

    {
      title: '经理',
      dataIndex: 'empManager',
      type: 'input',
      width: 100,
      align: 'center',
      resizable: true,
      autoHeight: true
    },
    {
      title: '颜色标记',
      dataIndex: 'tag',
      type: 'tag',
      width: 160,
      resizable: true,
      align: 'center',
      valueSetter: getValueSetter(),
      editable: 'cellEditorSlot',
      fixed: 'right'
    },
    {
      title: '操作',
      width: 280,
      resizable: true,
      key: 'operation',
      align: 'center',
      dataIndex: 'operation',
      fixed: 'right'
    }
  ]

  columns.value.forEach((item: any) => {
    if (canReportEdit.value.indexOf(item.dataIndex) != -1) {
      item.editable = (params: any) => {
        if (params.record.progress == 1) {
          return false
        } else {
          return 'cellEditorSlot'
        }
      }
    } else if (canDoEdit.value.indexOf(item.dataIndex) != -1) {
      return 'cellEditorSlot'
    } else {
      return false
    }
  })
  detail.value.push({
    title: '资源申请详情',
    children: columns
  })
}

const handleRefresh = () => {
  let pageUrl = `/main/customResourceApply/refresh`
  editPageData(pageUrl, currentData.value).then(() => {
    initTable(pagination.value, queryParam.value)
    ElMessage.success({
      message: '已刷新，请等待3分钟后查询统计数据',
      type: 'success',
      duration: 3 * 1000
    })
  })
}

initPermission()

dayjs.locale('zh-cn')

let count = 0
const customResourceRef = ref()
const corpNames: any = ref([])
const canUseCorp = [
  '南京秦淮天鼎证券投资',
  '天鼎证券投资秦淮',
  '天鼎证券投顾',
  '天鼎证券投资咨询',
  '江苏天鼎',
  '江苏天鼎秦淮'
]
const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData
    .filter((o: any) => canUseCorp.indexOf(o.name) != -1)
    .map((item: any) => {
      return { title: item.name, value: item.corPid }
    })

  corpNames.value = roleData.map((item: any) => {
    return {
      label: item.name,
      value: item.corPid,
      total: item.total,
      used: item.used
    }
  })
}
getCompanyList()

const formatCorpName = (record: any) => {
  if (record.corpId) {
    const row = corpNames.value.find((o: any) => o.value == record.corpId)
    if(row) {
      return (
        row.label +
        '<br/>(总数：<span style="color: #022bf8">' +
        row.total +
        '</span>/已用：<span style="color: red">' +
        row.used +
        '</span>)'
      )
    } else {
      return record.corpName
    }
  } else {
    return record.corpName
  }
}

const formatTag = (record: any) => {
  if (record.tag == '#FFC000') {
    return '打满标记完渠道'
  } else if (record.tag == '#548235') {
    return '刚打满缓存'
  } else if (record.tag == '#A9D18E') {
    return '在推'
  } else if (record.tag == '#FFFFFF' || !record.tag || record.tag == '') {
    return '待排'
  } else if (record.tag == '#A6A6A6') {
    return '异常'
  }
}

const handleDownload = () => {
  const fileName = '资源申请表.xlsx'
  downloadData(
    '/main/customResourceApply/downloadImport',
    {
      fileName: fileName
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = fileName
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const handleFillClick = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/customResourceApply/fill',
    query: {
      ...item,
      resourceType: 8
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenHeight * 0.9

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      initTable(pagination.value, queryParam.value)
    }
  }
}

const handleEditData = (item: any) => {
  const reportUrl = router.resolve({
    path: '/main/report/customResourceApply/detail',
    query: {
      ...item
    }
  }).href

  // 获取屏幕的宽度和高度
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height

  const width = screenWidth * 0.7
  const height = screenWidth * 0.7

  // 计算新窗口的左上角位置，使其居中
  const leftPosition = screenWidth / 2 - width / 2
  const topPosition = screenHeight / 2 - height / 2

  // 创建弹出窗口
  const options = `width=${width},height=${height},left=${leftPosition},top=${topPosition},toolbar=no,menubar=no,location=no,status=no,scrollbars=yes,resizable=yes`
  const popupWindow = window.open(reportUrl, '填报', options)
  if (popupWindow) {
    popupWindow.onbeforeunload = function () {
      initTable(pagination.value, queryParam.value)
    }
  }
}

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return { title: item.realName, value: item.id }
  })
  const userItem = searchFormConfig.formItems.find(
    (item) => item.field === 'empIds'
  )
  userItem!.options = userOptions
}
getEmp()

const getDept = () => {
  const dept = searchFormConfig.formItems.find(
    (item) => item.field === 'groupId'
  )
  dept!.isDisabled = store.state.login.userInfo.isManager != '1'
  const deptData = store.state.login.depts
  dept!.options = deptData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}
getDept()

let queryParam = ref()
if (userInfo.isManager != '1') {
  queryParam.value = {
    empIds: userInfo.id,
    isEnd: '',
    resourceType: 8
  }
} else {
  if(canDo) {
    queryParam.value = {
      isEnd: '',
      resourceType: 8
    }
  } else {
    queryParam.value = {
      groupId: userInfo.deptId,
      isEnd: '',
      resourceType: 8
    }
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)
const pagination = ref<STablePaginationConfig>({
  showQuickJumper: true,
  showSizeChanger: true,
  showTotal: (total) => `共 ${totalSize.value} 条`,
  pageSize: 10,
  current: 1
})

const onDelete = (id: string, key: string, args?: any) => {
  if ('' == id) {
    dataSource.value = dataSource.value.filter((item) => item.key !== key)
  } else {
    deletePageData('/main/customResourceApply/' + id).then(() => {
      initTable(pagination.value, queryParam.value)
    })
  }
  args?.hidePopup()
}

const handleCheck = (record: any) => {
  ElMessageBox.confirm('', {
    title: '审批',
    confirmButtonText: '同意',
    cancelButtonText: '驳回',
    distinguishCancelAndClose: true
  })
    .then((action) => {
      if ('confirm' == action) {
        record.applyStatus = '1'
        let pageUrl = `/main/customResourceApply/verify/${record.id}/${record.applyStatus}`
        editPageData(pageUrl, {}).then(() => {
          initTable(pagination.value, queryParam.value)
        })
      }
    })
    .catch((err) => {
      if ('cancel' == err) {
        record.applyStatus = '2'
      }
      let pageUrl = `/main/customResourceApply/verify/${record.id}/${record.applyStatus}`
      editPageData(pageUrl, {}).then(() => {
        initTable(pagination.value, queryParam.value)
      })
    })
}

const handleBegin = (record: any) => {
  ElMessageBox.confirm(`是否确认开始`, '提示', {
    type: 'success',
    center: true
  }).then(async () => {
    record.resourceType = 8
    handleBeginF(record)
  })
}

const handleBeginF = (record: any) => {
  record.progress = '1'
  let pageUrl = `/main/customResourceApply/progress/${record.id}/${record.progress}/${record.resourceType}`
  editPageData(pageUrl, {}).then(() => {
    initTable(pagination.value, queryParam.value)
  })
}

const handleEnd = (record: any) => {
  record.progress = '2'
  console.log(record)
  // if (
  //   record.actualDivideNum &&
  //   record.resourceType !== undefined &&
  //   record.resourceType !== null &&
  //   record.colleague &&
  //   record.nonPrecise &&
  //   record.withinTwoMonth &&
  //   record.difference
  // ) {
  //
  // } else {
  //   ElMessage.error('请填写完整打资源相关数据')
  // }
  let pageUrl = `/main/customResourceApply/progress/${record.id}/${record.progress}/${record.resourceType}`
  editPageData(pageUrl, {}).then(() => {
    initTable(pagination.value, queryParam.value)
    ElMessage.success({
      message: '已结束，请等待3分钟后查询统计数据',
      type: 'success',
      duration: 3 * 1000
    })
  })
}

const handleEndAndCreate = (record: any) => {
  const pageUrl = `/main/customResourceApply/endAndCreate/${record.id}/${record.resourceType}`
  editPageData(pageUrl, new URLSearchParams()).then(() => {
    initTable(pagination.value, queryParam.value)
    ElMessage.success('结束并新增成功')
  })
}

const currentData: any = ref({})

const beginDate = ref('')
const endDate = ref('')

const showReDo = ref(false)
const handleReDo = (record: any) => {
  showReDo.value = true
  currentData.value = record
  beginDate.value = record.beginDate
  endDate.value = record.endDate
}

const handleRedoF = () => {
  let pageUrl = `/main/customResourceApply/redo`
  currentData.value.beginDate = beginDate.value
  currentData.value.endDate = endDate.value
  editPageData(pageUrl, currentData.value).then(() => {
    initTable(pagination.value, queryParam.value)
    showReDo.value = false
    ElMessage.success({
      message: '已重新统计，请等待3分钟后查询统计数据',
      type: 'success',
      duration: 3 * 1000
    })
  })
}

const customHeaderCell = (column: any) => {
  if (column.editable) {
    return {
      style: { color: '#0000ff' }
    }
  }
}

const customCell = (obj: any) => {
  return {
    style: {
      backgroundColor: obj.record.tag
    }
  }
}

const handleAdd = (args?: any) => {
  const newData: any = {
    key: `${count}`,
    id: '',
    createBy: '',
    createTime: '',
    updateBy: '',
    updateTime: '',
    deleted: '',
    groupId: '',
    groupName: '',
    applyUserName: '',
    applyResourcesNum: '',
    applyDesc: '',
    wechatNo: '',
    corpWechatNo: '',
    account: '',
    corpId: '',
    corpName: '',
    remark: '',
    applyStatus: '',
    empId: '',
    upload: '',
    actualDivideNum: '',
    resourceType: '',
    upload0: '',
    beginDate: '',
    endDate: '',
    progress: '',
    colleague: '',
    nonPrecise: '',
    withinTwoMonth: '',
    withinAll: '',
    difference: '',
    verifyTime: '',
    verifyUser: '',
    progressUser: ''
  }
  count++
  dataSource.value.unshift(newData)
  dataSource.value = [].concat(dataSource.value)
  args?.hidePopup()
}

let totalSize = ref(0)

const handleSearchClick = (formdata: any) => {
  console.log(formdata)
  queryParam.value = formdata
  pagination.value.current = 1 //init page
  initTable(pagination.value, formdata)
}
const handleResetClick = () => {
  initTable(pagination.value, queryParam.value)
}

const dataSource: any = ref<DataItem[]>([])

const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`,
  Referer: 'no-referer'
}

const [
  uploadRef,
  extraData,
  files,
  action,
  beforeUpload,
  onSuccess,
  onExceed,
  filesMap
] = useUploadSimple()

const handleImgRemove = (uploadFile: any, uploadFiles: any) => {
  filesMap.value.delete(String(uploadFile.uid))
}

const currentRecord: any = ref({})
const currentColumnIndex = ref('')
const setCurrentRecord = (record: any, columnIndex: any) => {
  currentRecord.value = record
  currentColumnIndex.value = columnIndex
}

const showViewer = ref(false)
const previewSrcList = ref()
const handlePreview = (record: any, columnIndex: string) => {
  showViewer.value = true
  previewSrcList.value = record[columnIndex].split(',')
}
const closeViewer = () => {
  showViewer.value = false
}

const onSuccessUpload = () => {
  filesMap.value.forEach((value: string, key: string) => {
    currentRecord.value[currentColumnIndex.value] = value
  })
  editPageData(editUrl, currentRecord.value).then(() => {
    initTable(pagination.value, queryParam.value)
  })
}

const state = reactive<{
  selectedRowKeys: []
  loading: boolean
}>({
  selectedRowKeys: [], // Check here to configure the default column
  loading: false
})
const hasSelected = computed(() => state.selectedRowKeys.length > 0)
const selectedRowKeys = computed(() => state.selectedRowKeys)
const start = () => {
  state.loading = true
  // ajax request after empty completing
  setTimeout(() => {
    state.loading = false
    state.selectedRowKeys = []
  }, 1000)
}
const onSelectChange = (selectedRowKeys: []) => {
  console.log('selectedRowKeys changed: ', selectedRowKeys)
  state.selectedRowKeys = selectedRowKeys
}

const handleBatchDelete = () => {
  var pageNum = pagination.value.current || 1
  var pageSize = pagination.value.pageSize || 10
  ElMessageBox.confirm('确定要删除选中的数据吗', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'error',
    center: true
  }).then(() => {
    var ids = selectedRowKeys.value
      .map((o) => dataSource.value[parseInt(o)].id)
      .join(',')
    deletePageData('/main/customResourceApply/batch/' + ids).then(() => {
      initTable(pagination.value, queryParam.value)
      state.selectedRowKeys = []
      state.loading = false
    })
  })
}

const showMark = ref(false)

const handleBatchMark = () => {
  showMark.value = true
}

const batchMark = () => {
  if(colorOption.value) {
    if(selectedRowKeys.value.length > 0) {
      var pageNum = pagination.value.current || 1
      var pageSize = pagination.value.pageSize || 10
      ElMessageBox.confirm('确定要标记选中的数据吗', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        var ids = selectedRowKeys.value
          .map((o) => dataSource.value[parseInt(o)].id)
          .join(',')
        editPageData('/main/customResourceApply/batchMark',{
          ids: ids,
          color: colorOption.value
        }).then(() => {
          initTable(pagination.value, queryParam.value)
          state.selectedRowKeys = []
          state.loading = false
        })
      })
    } else {
      ElMessage.warning('请选择要标记的数据')
    }
  } else {
    ElMessage({
      message: '请选择标记颜色',
      type: 'warning'
    })
  }
}

const cancelBatchMark = () => {
  colorOption.value = ''
  showMark.value = false
}

const colorOption = ref('')
const colorOptions = ref([
  {
    value: '#FFC000',
    label: '打满标记完渠道-深黄'
  },
  {
    value: '#548235',
    label: '刚打满缓存-深绿'
  },
  {
    value: '#A9D18E',
    label: '在推-浅绿'
  },
  {
    value: '#FFFFFF',
    label: '待排-白色'
  },
  {
    value: '#A6A6A6',
    label: '异常-深灰'
  }
])

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleExport = () => {
  getPageListData(
    '/main/customResourceApply/download',
    {
      ...queryParam.value,
      pageNo: pagination.value.current,
      pageSize: pagination.value.pageSize
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    }) //处理文档流
    const down = document.createElement('a')
    down.download =
      '资源打满名单' +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const initTable = (params: STablePaginationConfig = {}, query?: any) => {
  getPageListData('/main/customResourceApply/queryByCondition', {
    ...query,
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize
  }).then((res) => {
    dataSource.value = res.list
    totalSize.value = res.total
    count = dataSource.value.length
    pagination.value = {
      ...params,
      total: totalSize.value
    }
  })
}
onMounted(() => {
  initTable(pagination.value, queryParam.value)
})

watch(
  () => ({ ...pagination.value }),
  (cur, pre) => {
    if (cur.current !== pre.current || cur.pageSize !== pre.pageSize) {
      initTable(pagination.value, queryParam.value)
    }
  }
)

function getValueSetter() {
  return ({ record, column, row, newValue, oldValue }: any) => {
    let stack = new Error().stack
    if (stack!.indexOf('handleKeyDown') != -1) {
      return true
    }
    let field = column.dataIndex
    let body: any = {}
    body[field] = newValue
    body['id'] = record.id
    editPageData(editUrl, body).then(() => {
      initTable(pagination.value, queryParam.value)
    })
    return true
  }
}
const router = useRouter()
const currentItem = ref({})
const showDetail = ref(false)
const handleDetailData = (item: any) => {
  currentItem.value = item
  showDetail.value = true
}

const [
  pageModalTableRef,
  defaultTableInfo,
  dataList,
  handleViewClick,
  dataCount,
  handleSortChange
] = usePageModalTable()

const formatRepeatPercent = (record: any) => {
  // 计算百分比 record.withinAll / record.actualDivideNum
  if (record.withinAll && record.actualDivideNum) {
    return ((record.withinAll / record.actualDivideNum) * 100).toFixed(2) + '%'
  } else {
    return '-'
  }
}

const formatDelete24hPercent = (record: any) => {
  // 计算24小时删除率 record.deleteWithin24h / record.actualDivideNum
  if (record.deleteWithin24h !== undefined && record.deleteWithin24h !== null && record.actualDivideNum) {
    return ((record.deleteWithin24h / record.actualDivideNum) * 100).toFixed(2) + '%'
  } else {
    return '-'
  }
}

const importAction =
  process.env.VUE_APP_BASE_URL +
  '/main/customResourceApply/dataImport?resourceType=8'

const handleImportSuccess = (res: any) => {
  console.log(res)
  if (res.length > 0) {
    const errs = res.map((item: any) => item.reason).join(',')
    ElMessage({
      type: 'error',
      message: '导入存在异常数据如下：' + errs
    })
  } else {
    initTable(pagination.value, queryParam.value)
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  }
}

const handleImportError = (res: any) => {
  console.log(res)
}

const checkDate = (record: any) => {
  const today = dayjs()
  const startDate = dayjs(record.beginDate)
  // 判断今天是否与开始日期在同一月份
  return startDate.month() === today.month()
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_s_table = _resolveComponent("s-table")!
  const _component_el_image_viewer = _resolveComponent("el-image-viewer")!
  const _component_PageModalTable = _resolveComponent("PageModalTable")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      ref: customResourceRef.value,
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "default",
          size: "medium",
          loading: state.loading,
          onClick: start
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消全选")
          ]),
          _: 1
        }, 8, ["loading"]),
        _createElementVNode("span", _hoisted_4, [
          (hasSelected.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(`已选中 ${selectedRowKeys.value.length} 行`), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_upload, {
          style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
          action: importAction,
          headers: headers.value,
          accept: ".xls,.xlsx",
          "on-success": handleImportSuccess,
          "on-error": handleImportError,
          "show-file-list": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              size: "medium",
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("数据导入")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["headers"]),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleDownload
        }, {
          default: _withCtx(() => [
            _createTextVNode("模板下载")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleFillClick
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [
            _createTextVNode("数据更新")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleBatchDelete
        }, {
          default: _withCtx(() => [
            _createTextVNode("批量删除")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleBatchMark
        }, {
          default: _withCtx(() => [
            _createTextVNode("批量标记")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "medium",
          onClick: handleExport
        }, {
          default: _withCtx(() => [
            _createTextVNode("数据导出")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_s_table, {
      bordered: "",
      "data-source": dataSource.value,
      columns: columns.value,
      stripe: "",
      pagination: pagination.value,
      "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((pagination).value = $event)),
      scroll: { x: 2000 },
      sticky: "",
      "show-header-scrollbar": "",
      "auto-header-height": "",
      "row-selection": {
        selectedRowKeys: selectedRowKeys.value,
        onChange: onSelectChange
      },
      "custom-header-cell": customHeaderCell,
      "custom-cell": customCell
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (dataSource.value.length && _unref(canReport))
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "确定要删除吗?",
                    onConfirm: ($event: any) => (onDelete(record.id, record.key))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : _createCommentVNode("", true),
              (dataSource.value.length && _unref(canReport))
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 1,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleEditData(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("编辑")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (dataSource.value.length && _unref(canDo) && record.progress == 0)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 2,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleBegin(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("开始")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (dataSource.value.length && _unref(canDo) && record.progress == 1)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 3,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleEnd(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("结束")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (dataSource.value.length && _unref(canDo) && record.progress == 1)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 4,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleEndAndCreate(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("结束并新增")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (
                dataSource.value.length &&
                _unref(canDo) &&
                record.progress == 2 &&
                checkDate(record)
              )
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 5,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleReDo(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重新统计")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (dataSource.value.length && record.progress == 2)
                ? (_openBlock(), _createBlock(_component_el_link, {
                    key: 6,
                    type: "primary",
                    underline: false,
                    onClick: _withModifiers(($event: any) => (handleDetailData(record)), ["stop","prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'upload' || column.dataIndex === 'upload0')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (record.applyStatus == 0)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    referrerpolicy: "no-referrer",
                    ref_key: "uploadRef",
                    ref: uploadRef,
                    "auto-upload": true,
                    action: _unref(action),
                    headers: headers.value,
                    data: _unref(extraData),
                    "before-upload": _unref(beforeUpload),
                    "on-success": onSuccessUpload,
                    "on-exceed": _unref(onExceed),
                    accept: ".jpeg,.jpg,.png",
                    "on-remove": handleImgRemove,
                    "show-file-list": false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "mini",
                        type: "primary",
                        onClick: ($event: any) => (setCurrentRecord(record, column.dataIndex))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("上传")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["action", "headers", "data", "before-upload", "on-exceed"]))
                : _createCommentVNode("", true),
              (record[column.dataIndex])
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    size: "mini",
                    type: "primary",
                    onClick: ($event: any) => (handlePreview(record, column.dataIndex))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : (column.dataIndex === 'corpId')
            ? (_openBlock(), _createElementBlock("span", {
                key: 2,
                innerHTML: formatCorpName(record)
              }, null, 8, _hoisted_9))
            : (column.dataIndex === 'tag')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 3,
                  innerHTML: formatTag(record)
                }, null, 8, _hoisted_10))
              : (column.dataIndex === 'resourceType')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(record.resourceTypeDesc), 1))
                : _createCommentVNode("", true),
        (column.dataIndex === 'actualDivideNum')
          ? (_openBlock(), _createBlock(_component_el_link, {
              key: 5,
              style: {"color":"#55a532","text-decoration":"underline"},
              onClick: _withModifiers(($event: any) => (
              _unref(handleViewClick)(record, '/main/customResourceApply/dataList')
            ), ["stop","prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(record.actualDivideNum), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'withinAllPer')
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(formatRepeatPercent(record)), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'deleteWithin24hPer')
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(formatDelete24hPercent(record)), 1))
          : _createCommentVNode("", true)
      ]),
      cellEditor: _withCtx(({ column, modelValue, save, closeEditor, editorRef }) => [
        (column.type === 'date')
          ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 0,
              locale: _unref(locale),
              ref: editorRef,
              bordered: false,
              value: 
              _unref(dayjs)(
                modelValue.value
                  ? modelValue.value
                  : _unref(dayjs)(`${new Date()}`).format('YYYY-MM-DD')
              )
            ,
              style: {"width":"100%"},
              open: "",
              "allow-clear": false,
              "onUpdate:value": 
              (v) => {
                modelValue.value = v?.format('YYYY-MM-DD') ?? ''
                save()
              }
            ,
              onBlur: closeEditor,
              onKeydown: _withKeys(closeEditor, ["esc"]),
              onClick: _withModifiers(closeEditor, ["stop"])
            }, null, 8, ["locale", "value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
          : _createCommentVNode("", true),
        (column.type === 'dateTime')
          ? (_openBlock(), _createBlock(_component_a_date_picker, {
              key: 1,
              "show-time": "",
              locale: _unref(locale),
              ref: editorRef,
              bordered: false,
              value: 
              _unref(dayjs)(
                modelValue.value
                  ? modelValue.value
                  : _unref(dayjs)(`${new Date()}`).format('YYYY-MM-DD HH:mm:ss')
              )
            ,
              style: {"width":"100%"},
              open: "",
              "allow-clear": false,
              "onUpdate:value": 
              (v) => {
                modelValue.value = v?.format('YYYY-MM-DD HH:mm:ss') ?? ''
                save()
              }
            ,
              onBlur: closeEditor,
              onKeydown: _withKeys(closeEditor, ["esc"]),
              onClick: _withModifiers(closeEditor, ["stop"])
            }, null, 8, ["locale", "value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
          : (column.type === 'resourceType')
            ? (_openBlock(), _createBlock(_component_a_select, {
                key: 2,
                ref: editorRef,
                bordered: true,
                value: modelValue.value,
                style: {"width":"120px"},
                options: [
              {
                value: '0',
                label: '诊股'
              },
              {
                value: '1',
                label: '信息流'
              },
              { label: '百度直播', value: 2},
        { label: '视频号直播', value: 3},
        { label: '三方视频号直播', value: 4},
        { label: '打新', value: 5},
        { label: '送股', value: 6}
            ],
                open: "",
                "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                onBlur: closeEditor,
                onKeydown: _withKeys(closeEditor, ["esc"]),
                onClick: _withModifiers(closeEditor, ["stop"])
              }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
            : (column.type === 'tag')
              ? (_openBlock(), _createBlock(_component_a_select, {
                  key: 3,
                  ref: editorRef,
                  bordered: true,
                  value: modelValue.value,
                  style: {"width":"120px"},
                  options: [
              {
                value: '#FFC000',
                label: '打满标记完渠道-深黄'
              },
              {
                value: '#548235',
                label: '刚打满缓存-深绿'
              },
              {
                value: '#A9D18E',
                label: '在推-浅绿'
              },
              {
                value: '#FFFFFF',
                label: '待排-白色'
              },
              {
                value: '#A6A6A6',
                label: '异常-深灰'
              }
            ],
                  open: "",
                  "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                  onBlur: closeEditor,
                  onKeydown: _withKeys(closeEditor, ["esc"]),
                  onClick: _withModifiers(closeEditor, ["stop"])
                }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
              : (column.type === 'corpId')
                ? (_openBlock(), _createBlock(_component_a_select, {
                    key: 4,
                    ref: editorRef,
                    bordered: true,
                    value: modelValue.value,
                    style: {"width":"120px"},
                    options: corpNames.value,
                    open: "",
                    "onUpdate:value": 
              (v) => {
                modelValue.value = v
                save()
              }
            ,
                    onBlur: closeEditor,
                    onKeydown: _withKeys(closeEditor, ["esc"]),
                    onClick: _withModifiers(closeEditor, ["stop"])
                  }, null, 8, ["value", "options", "onUpdate:value", "onBlur", "onKeydown", "onClick"]))
                : (column.type == 'textarea')
                  ? (_openBlock(), _createBlock(_component_a_textarea, {
                      key: 5,
                      ref: editorRef,
                      bordered: true,
                      value: modelValue.value,
                      autosize: "true",
                      "onUpdate:value": 
              (v) => {
                modelValue.value = v
              }
            ,
                      onBlur: save,
                      onKeydown: _withKeys(closeEditor, ["esc"])
                    }, null, 8, ["value", "onUpdate:value", "onBlur", "onKeydown"]))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "columns", "pagination", "row-selection"]),
    (showViewer.value)
      ? (_openBlock(), _createBlock(_component_el_image_viewer, {
          key: 0,
          "url-list": previewSrcList.value,
          onClose: closeViewer,
          infinite: false
        }, null, 8, ["url-list"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageModalTable, {
      title: "",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: _unref(dataList),
      dataCount: _unref(dataCount),
      onSortChange: _unref(handleSortChange)
    }, null, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount", "onSortChange"]),
    _createVNode(_component_el_dialog, {
      title: "重新统计",
      center: "",
      modelValue: showReDo.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showReDo).value = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleRedoF
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showReDo.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 取消 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "form",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "开打日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: beginDate.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((beginDate).value = $event)),
                  "value-format": "YYYY-MM-DD",
                  type: "date",
                  placeholder: "选择开打日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "打满日期" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: endDate.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
                  "value-format": "YYYY-MM-DD",
                  type: "date",
                  placeholder: "选择打满日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "详情",
      modelValue: showDetail.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showDetail).value = $event)),
      width: "50%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.filter(
            (o) => o.dataIndex != 'operation'
          ), (column, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "div-table-row",
              key: idx
            }, [
              (column.children)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(column.title), 1))
                : _createCommentVNode("", true),
              (column.children)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.children.filter(
                (o) => o.dataIndex != 'operation'
              ), (col, k) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: k,
                        class: _normalizeClass(
                'div-table-col ' + (col.flexBasicAll ? 'flexBasicAll' : '')
              )
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(col.title), 1),
                        (col.dataIndex.indexOf('upload') == -1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (col.dataIndex == 'corpId')
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    innerHTML: formatCorpName(currentItem.value)
                                  }, null, 8, _hoisted_20))
                                : (col.dataIndex == 'tag')
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      innerHTML: formatTag(currentItem.value)
                                    }, null, 8, _hoisted_21))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(currentItem.value[col.dataIndex]), 1))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createVNode(_component_el_image, {
                                src: currentItem.value[col.dataIndex],
                                referrerpolicy: 'no-referrer',
                                "preview-src-list": currentItem.value[col.dataIndex],
                                style: {"width":"100px","height":"100px"},
                                fit: "cover"
                              }, null, 8, ["src", "preview-src-list"])
                            ]))
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(column.title), 1),
                      _createElementVNode("div", _hoisted_27, _toDisplayString(currentItem.value[column.dataIndex]), 1)
                    ])
                  ]))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量标记",
      modelValue: showMark.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showMark).value = $event)),
      width: "30%",
      "close-on-click-modal": false,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", null, [
            _createVNode(_component_el_select, {
              modelValue: colorOption.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((colorOption).value = $event)),
              clearable: "",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorOptions.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: batchMark
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, { onClick: cancelBatchMark }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})